import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { SnackBarService } from 'src/app/shared-modules/stateless/snack-bar/services';

import { TimeZonesService } from '../../services';
import * as fromActions from '../actions';

@Injectable()
export class TimeZonesEffects {
  constructor(
    private actions$: Actions,
    private timeZonesService: TimeZonesService,
    private snackBar: SnackBarService
  ) {}

  loadTimeZones$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadTimeZones),
      switchMap(() =>
        this.timeZonesService.loadTimeZones().pipe(
          map((data) => fromActions.loadTimeZonesSuccess({ payload: data })),
          catchError((error) =>
            of(fromActions.loadTimeZonesFailure({ payload: error }))
          )
        )
      )
    )
  );

  loadTimeZonesFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromActions.loadTimeZonesFailure),
        tap(({ payload }) => {
          this.snackBar.open(
            `Failed to load time zones, ${payload?.message}`,
            'FAILURE',
            3000
          );
        })
      );
    },
    { dispatch: false }
  );
}
